/**
 * A VerticalGridDynamic that appends "next photo" waiting cells after the photos, as many as the panel
 * asks for. They are added only to the DISPLAY data (the data getter), never to the bound received-photos
 * array : import, count and discard stay untouched.
 *
 * Shared by the desktop and mobile SelectPhotosPanel (shared.panels.SelectPhotosPanelBase).
 */
fx.ns("shared.components", class ReceivingGrid extends fx.components.VerticalGridDynamic {

	get data()
	{
		let base = super.data;

		// none waiting : hand back the source untouched. The base reads .data (length / .more) on
		// every scroll, so a per-read array copy would allocate on every scroll frame for nothing.
		if (!this._waiting || !this._waiting.length)
			return base;

		let arr = base ? (base instanceof fx.ModelArray ? base.toArray() : base.slice()) : [];
		return arr.concat(this._waiting);
	}

	set data(val)
	{
		super.data = val;
	}

	/**
	 * How many waiting cells follow the photos. The source announces its total before the first photo
	 * lands, so the panel asks for one cell per photo still to come and the grid shows the shape of the
	 * whole import from the start, filling in as the photos replace the cells.
	 */
	showPlaceholder(count)
	{
		count = Math.max(0, Math.floor(count) || 0);

		let waiting = this._waiting || (this._waiting = []);

		if (waiting.length === count)
			return;

		// kept rather than rebuilt : the cells that stay keep their id, so the grid reuses their
		// renderers instead of redrawing every one of them on each photo that arrives
		while (waiting.length < count)
			waiting.push(new shared.models.NextPhotoPlaceholder(waiting.length));

		waiting.length = count;

		if (this.initialized)
			this.forceUpdate();
	}

	// the panel / window was resized : drop the stale structure so it is re-estimated at the new
	// width (the base only recalculates visible rows and keeps the old layout, so a tile that no
	// longer fits would overflow instead of wrapping)
	onDisplayUpdated()
	{
		this._structure = null;

		super.onDisplayUpdated();
	}
});
